<div
	class="search-results px-[46px]"
	infiniteScroll
	[infiniteScrollDistance]="1"
	[infiniteScrollUpDistance]="1.5"
	[infiniteScrollThrottle]="50"
	(scrolled)="onScrollDown($event)"
>
	<div class="mb-24px overflow-x-auto">
		<app-tabs
			[taps]="NotificationStatus"
			[activeTap]="NotificationFilter.NotificationTap"
			(tapChanged)="
				NotificationFilter.Paging.PageNumber = 1;
				NotificationFilter.NotificationTap = $event;
				getNotifications()
			"
		>
		</app-tabs>
	</div>
	<div
		*ngIf="notifications?.length"
		class="px-[16px] py-[24px] bg-[#FCFCFC] rounded-[12px]"
	>
		<div *ngFor="let notification of notifications" class="mb-[12px]">
			<app-notification-card
				[notification]="notification"
			></app-notification-card>
			<!-- <hr class="w-full text-medium-gray" /> -->
		</div>
	</div>
</div>

<app-no-data-found
	*ngIf="!notifications?.length"
	text="NOTIFICATIONS.NO_NOTIFICATIONS_FOUND"
></app-no-data-found>
